import React, { useState } from 'react';

const Tabs = ({ tabs, currentTab, onTabClick }) => {
  return (
    <ul className="nav nav-tabs" style={{borderRadius:"8px",padding:"5px"}}>
      {tabs.map((tab, index) => (
        <li className="nav-item" key={index}>
          <a
            className={`nav-link ${currentTab === index ? 'active' : ''}`}
            onClick={() => onTabClick(index)}
          >
            {tab.title}
          </a>
        </li>
      ))}
    </ul>
  );
};

export default Tabs;
